import { render, staticRenderFns } from "./InformasiBongkarAdd.vue?vue&type=template&id=2908534a&scoped=true"
import script from "./InformasiBongkarAdd.vue?vue&type=script&lang=js"
export * from "./InformasiBongkarAdd.vue?vue&type=script&lang=js"
import style0 from "./InformasiBongkarAdd.vue?vue&type=style&index=0&id=2908534a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908534a",
  null
  
)

export default component.exports